import { Document, Font } from "@react-pdf/renderer";

import TitlePage from "./pages/TitlePage";
import ObjectPage from "./pages/ObjectPage";
import RelatedObjectsPage from "./pages/RelatedObjectsPage";
import RelatedEmployeePage from "./pages/RelatedEmployeePage";
import FilePage from "./pages/FilePage";

// Регистрация шрифтов для PDF
Font.register({
  family: "Inter",
  fonts: [
    {
      src: "/pdfFonts/Inter-Thin.ttf",
      fontStyle: "normal",
      fontWeight: 100,
    },
    {
      src: "/pdfFonts/Inter-ExtraLight.ttf",
      fontStyle: "normal",
      fontWeight: 200,
    },
    {
      src: "/pdfFonts/Inter-Light.ttf",
      fontStyle: "normal",
      fontWeight: 300,
    },
    {
      src: "/pdfFonts/Inter-Regular.ttf",
      fontStyle: "normal",
      fontWeight: 400,
    },
    {
      src: "/pdfFonts/Inter-Medium.ttf",
      fontStyle: "normal",
      fontWeight: 500,
    },
    {
      src: "/pdfFonts/Inter-SemiBold.ttf",
      fontStyle: "normal",
      fontWeight: 600,
    },
    {
      src: "/pdfFonts/Inter-Bold.ttf",
      fontStyle: "normal",
      fontWeight: 700,
    },
    {
      src: "/pdfFonts/Inter-ExtraBold.ttf",
      fontStyle: "normal",
      fontWeight: 800,
    },
    {
      src: "/pdfFonts/Inter-Black.ttf",
      fontStyle: "normal",
      fontWeight: 900,
    },
  ],
});

// Компонент PDF
const PDF = ({ data, navs, config, screenshots }) => {
  const title = data.object.name;
  const createdDate = data.data.created_at;
  const author = data.data.author;

  return (
    <Document title={title} author={author}>
      <TitlePage
        title={title}
        author={author}
        createdDate={createdDate}
        definition={data.data.definition?.name}
        navs={navs}
        config={config}
      />
      {/* Основной объект */}
      <ObjectPage
        id={data.object.uuid}
        title={title}
        author={author}
        createdDate={createdDate}
        object={data.object}
        groupsFields={data.groupsFields}
        config={config}
        screenshots={screenshots}
      />
      {/* Подобъекты */}
      {data.subObjects.map((subObject) => {
        return (
          <ObjectPage
            key={subObject.object.uuid}
            id={subObject.object.uuid}
            title={subObject.object.name}
            author={author}
            createdDate={createdDate}
            object={subObject.object}
            groupsFields={
              subObject.definition.groups
                .filter(({ fields }) => !!fields && !!fields.length)
                .sort((a, b) => a.idx - b.idx) || []
            }
            config={config}
            screenshots={screenshots}
          />
        );
      })}
      {/* Связанные объекты */}
      <RelatedObjectsPage
        id="related-objects"
        title="Связанные объекты"
        author={author}
        createdDate={createdDate}
        objects={data.relatedObjects}
        config={config}
      />
      {/* Сотрудники */}
      {data.relatedEmployees.map((employee) => {
        return (
          <RelatedEmployeePage
            key={employee.field_uuid}
            id={employee.field_uuid}
            title={employee.field_name}
            author={author}
            createdDate={createdDate}
            employee={employee}
            config={config}
          />
        );
      })}

      {/* Файлы */}
      {data.files.map((file) => {
        return (
          <FilePage
            key={file.uuid}
            id={file.uuid}
            title={file.original_name}
            author={author}
            createdDate={createdDate}
            file={file}
            config={config}
          />
        );
      })}
    </Document>
  );
};

export default PDF;
